/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * Server, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HttpValidationProblemDetails,
  ProblemDetails
} from '../models';

import { customInstance } from '../../../orvalCustomAxiosInstance';
import type { ErrorType } from '../../../orvalCustomAxiosInstance';




/**
 * Get a list of available document templates from SharePoint.
 */
export const getApiSharePointTemplates = (

 signal?: AbortSignal
) => {


      return customInstance<string[]>(
      {url: `/api/SharePoint/templates`, method: 'GET', signal
    },
      );
    }




export const getGetApiSharePointTemplatesQueryKey = () => {
    return [
    `/api/SharePoint/templates`
    ] as const;
    }


export const getGetApiSharePointTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof getApiSharePointTemplates>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointTemplates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSharePointTemplatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSharePointTemplates>>> = ({ signal }) => getApiSharePointTemplates(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSharePointTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSharePointTemplates>>>
export type GetApiSharePointTemplatesQueryError = ErrorType<ProblemDetails | HttpValidationProblemDetails>


export function useGetApiSharePointTemplates<TData = Awaited<ReturnType<typeof getApiSharePointTemplates>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSharePointTemplates>>,
          TError,
          Awaited<ReturnType<typeof getApiSharePointTemplates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSharePointTemplates<TData = Awaited<ReturnType<typeof getApiSharePointTemplates>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSharePointTemplates>>,
          TError,
          Awaited<ReturnType<typeof getApiSharePointTemplates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSharePointTemplates<TData = Awaited<ReturnType<typeof getApiSharePointTemplates>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointTemplates>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSharePointTemplates<TData = Awaited<ReturnType<typeof getApiSharePointTemplates>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointTemplates>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSharePointTemplatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get a list of available markdown templates from SharePoint.
 */
export const getApiSharePointMarkdownTemplates = (

 signal?: AbortSignal
) => {


      return customInstance<string[]>(
      {url: `/api/SharePoint/markdown-templates`, method: 'GET', signal
    },
      );
    }




export const getGetApiSharePointMarkdownTemplatesQueryKey = () => {
    return [
    `/api/SharePoint/markdown-templates`
    ] as const;
    }


export const getGetApiSharePointMarkdownTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSharePointMarkdownTemplatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>> = ({ signal }) => getApiSharePointMarkdownTemplates(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSharePointMarkdownTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>>
export type GetApiSharePointMarkdownTemplatesQueryError = ErrorType<ProblemDetails | HttpValidationProblemDetails>


export function useGetApiSharePointMarkdownTemplates<TData = Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>,
          TError,
          Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSharePointMarkdownTemplates<TData = Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>,
          TError,
          Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSharePointMarkdownTemplates<TData = Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSharePointMarkdownTemplates<TData = Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplates>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSharePointMarkdownTemplatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Download markdown template content from SharePoint.
 */
export const getApiSharePointMarkdownTemplatesTemplateName = (
    templateName: string,
 signal?: AbortSignal
) => {


      return customInstance<string>(
      {url: `/api/SharePoint/markdown-templates/${templateName}`, method: 'GET', signal
    },
      );
    }




export const getGetApiSharePointMarkdownTemplatesTemplateNameQueryKey = (templateName: string,) => {
    return [
    `/api/SharePoint/markdown-templates/${templateName}`
    ] as const;
    }


export const getGetApiSharePointMarkdownTemplatesTemplateNameQueryOptions = <TData = Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(templateName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSharePointMarkdownTemplatesTemplateNameQueryKey(templateName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>> = ({ signal }) => getApiSharePointMarkdownTemplatesTemplateName(templateName, signal);





   return  { queryKey, queryFn, enabled: templateName !== null && templateName !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSharePointMarkdownTemplatesTemplateNameQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>>
export type GetApiSharePointMarkdownTemplatesTemplateNameQueryError = ErrorType<ProblemDetails | HttpValidationProblemDetails>


export function useGetApiSharePointMarkdownTemplatesTemplateName<TData = Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 templateName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>,
          TError,
          Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSharePointMarkdownTemplatesTemplateName<TData = Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 templateName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>,
          TError,
          Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSharePointMarkdownTemplatesTemplateName<TData = Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 templateName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSharePointMarkdownTemplatesTemplateName<TData = Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 templateName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharePointMarkdownTemplatesTemplateName>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSharePointMarkdownTemplatesTemplateNameQueryOptions(templateName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






